import React from "react";
import useCiclosLogic from "./hooks/useCiclosLogic";
import CiclosView from "./pages/CiclosView.jsx";

export default function Ciclos() {
  const logic = useCiclosLogic();
  return <CiclosView {...logic} />;
}
